import CustomRichText from './CustomRichText'

export default CustomRichText
